// Scripts librairies
// import { docReady } from './js/libs/utils'

// Charge la base commune
require('./common.js')
